export enum Brand {
  Carnival = 'CCL',
  UVCExperiences = 'UVX',
  UExperiencesMexico = 'UXM',
  UExperiencesCanada = 'UXC',
  ONE = 'OMC',
  MedallionClassMarket = 'MCM',
  GuestBookings = 'GBK',
  GuestBookingsUK = 'GBU',
  CapitalVacationsClub = 'CVC',
  FutureCruisePackages = 'FCP',
  FutureCruisePackagesCanada = 'CAN',
  FutureCruisePackagesUk = 'PCU',
  ClubPrincess = 'CPR',
  Victra = 'VIC',
  BassPro = 'BPR',
  SanDiego = 'SDG',
  Prestigate = 'PRN',
  PrincessPartnerRewards = 'PPR',
  Vivri = 'VIV',
  MagicBreak = 'MBO',
  HolidayInnClub = 'HIC',
  HolidayInnClubVacations = 'HICV',
  ClubVacay = 'CVY',
  GuestBookingsAMZ = 'AMZ',
  MemberGetaways = 'MGW',
  HotelsByCruisecom = 'HBC',
  PrincessCUG = 'CUG',
  ElCidShopAtHome = 'ELX',
  TravelGuestBookings = 'TGB',
  EmployeeBenefits = 'OEB',
  ExploreByPuebloBonito = 'EPB',
  ExploreByPuebloBonitoMexico = 'PBM',
  SupplierTesting = 'STG',
  LeisureRewards = 'LER',
  Aspirex = 'ASP',
  CruiseComPlus = 'CRP',
  Bookit = 'BKI',
  MyBookit = 'BKC',
  ArmedForcesVacationClub = 'AFVC',
  RCI = 'RCI',
  KimptonClub = 'KIM',
  AirShop = 'AIRS',
  Emerald = 'EMD',
}

export const UK_Brands = [Brand.GuestBookingsUK.toString(), Brand.FutureCruisePackagesUk.toString()];
